/**
 * @description： 文本次数统计类，用来统计一段文本有多少字数
 * @author wangjie
 * @since 2020/4/16
 */

const WHITE_CHARS =
    ['\b', '\f', '\n', '\r', '\t', '\v', ' '].map(c => c.charCodeAt(0));
const CJK_RANGES = [
    [0x4e00, 0x9fbb],
    [0xff00, 0xffff],
    [0x2e80, 0x2eff],
    [0x3000, 0x303f],
    [0x31c0, 0x31ef],
    [0x3040, 0x309f],
    [0x30a0, 0x30ff],
    [0x31f0, 0x31ff],
    [0xac00, 0xd7af]
]

class CharCodeEnumer {
    constructor(str) {
        if (!str) {
            this._length = 0;
            return;
        } else {
            this._str = str;
            this._length = this._str.length;
        }
        this._currentPosition = 0;

        this._enumCodeFunc = String.prototype.codePointAt ?
            () => {
                let str = this._str;
                const codeNumber = str.codePointAt(this._currentPosition);
                if (codeNumber > 0xFFFF) this._currentPosition += 2;
                else this._currentPosition += 1;

                return codeNumber;
            } :
            () => {
                const code = str.charCodeAt(this._str[this._currentPosition]);
                this._currentPosition++;
                return code;
            };
    }

    get canMoveNext() {
        return this._currentPosition <= this._length - 1;
    }

    moveNext() {
        if (this.canMoveNext) {
            return this._enumCodeFunc();
        }

        return -1;
    }
}

const CHAR_CODE_TYPES = {
    whiteCode: 0,
    cjkCode: 1,
    ansiCode: 2
}

function isWhite(charCode) {
    return WHITE_CHARS.indexOf(charCode) > -1;
}

function isCJK(charCode) {
    for (let range of CJK_RANGES) {
        if (charCode >= range[0] && charCode <= range[1]) {
            return true;
        }
    }
    return false;
}
function countWords(str) {
    if (!str || str.length < 0 || str.trim() == 0) return 0;

    let codeCache = [];
    let wordCount = 0;
    const codeEnumer = new CharCodeEnumer(str.trim());
    let curCodeNumber = -1;
    while (codeEnumer.canMoveNext) {
        curCodeNumber = codeEnumer.moveNext();

        if (isWhite(curCodeNumber)) {
            if (codeCache.length < 1) {
                codeCache.push(CHAR_CODE_TYPES.whiteCode);
            }
            else {
                if (codeCache[codeCache.length - 1] == CHAR_CODE_TYPES.whiteCode) {
                    continue;
                } else if (codeCache[codeCache.length - 1] == CHAR_CODE_TYPES.ansiCode) {
                    wordCount++;
                    codeCache = []
                }
            }
        } else if (isCJK(curCodeNumber)) {
            if (codeCache.length > 0 && codeCache[codeCache.length - 1] == CHAR_CODE_TYPES.ansiCode) {
                wordCount++;
            }

            codeCache = []
            wordCount++;
        } else {
            if (codeCache.length == 0) codeCache.push(CHAR_CODE_TYPES.ansiCode);
            else {
                const lastCacheCodeType = codeCache[codeCache.length - 1];
                //codes in codeCache can only be white or ansi
                if (lastCacheCodeType == CHAR_CODE_TYPES.ansiCode) {
                    codeCache.push(CHAR_CODE_TYPES.ansiCode);
                } else {
                    codeCache = [CHAR_CODE_TYPES.ansiCode];
                }
            }
        }
    }

    if (codeCache.length > 0) {
        if (codeCache[codeCache.length - 1] == CHAR_CODE_TYPES.ansiCode) {
            wordCount++;
        }
    }

    return wordCount;
}

export {
    countWords
}